import { white100 } from 'ext-ui/style/colors'
import { createGlobalStyle } from 'styled-components'

// Class names for the legacy Popup card. The defaults below reproduce the
// pre-migration white box (width, padding, responsive breakpoints) so Popup keeps
// its look, and BaseModal renders a bare body (`unstyledBody`) around this card —
// keeping consumer css/className overrides on a single box.
export const POPUP_CARD_CLASS = 'Popup-card'
export const POPUP_CARD_NO_PADDING_CLASS = 'Popup-card-noPadding'

// Legacy box dimensions (styleConstants.widths.popup / borderRadius.box) and
// breakpoints (XSM / XXSM), inlined so this style module has no module-load
// dependency on @paywithextend/components — that import is mocked incompletely in
// several test suites, and createGlobalStyle evaluates its interpolations eagerly.
const POPUP_CARD_WIDTH = '700px'
const POPUP_CARD_RADIUS = '10px'
const XSM_DOWN = '@media (max-width: 767px)'
const XXSM_ONLY = '@media (max-width: 567px)'

// Specificity is split deliberately across two selectors:
//
// 1. Surface + width go in `:where(.Popup-card)`, specificity (0,0,0). A consumer
//    class forwarded from `<Popup css={…}>` / `className` lands on the same element
//    at (0,1,0) and so wins `width` overrides (ManageOrgInvite 500px,
//    UpdateProfilePhoto 600px, RegisterAccount 900px) by SPECIFICITY — deterministic,
//    independent of stylesheet insertion order. The global `* {…}` reset in
//    src/style/baseGlobalStyles.tsx sets only `padding`/`margin`/`box-sizing`, none
//    of which collide here (box-sizing is identical), so (0,0,0) is safe for these.
//
// 2. `padding` goes in a real `.Popup-card` class, specificity (0,1,0), so it BEATS
//    the universal `* { padding: 0 }` reset — which a `:where()` (0,0,0) only ties
//    and then loses on source order, the regression that collapsed card padding to 0.
//    The sanctioned padding override is the `noPadding` prop → `.Popup-card-noPadding`,
//    declared immediately after and in the SAME block, so it wins by guaranteed source
//    order. (Consumers that need zero padding must use `noPadding`, not a css override.)
//
// Rendering this component per-Popup is safe: styled-components de-duplicates the
// injection.
export const PopupCardGlobalStyle = createGlobalStyle`
  :where(.${POPUP_CARD_CLASS}) {
    box-sizing: border-box;
    background-color: ${white100};
    border-radius: ${POPUP_CARD_RADIUS};
    box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.15);
    width: ${POPUP_CARD_WIDTH};

    ${XSM_DOWN} {
      width: 100%;
    }
  }

  .${POPUP_CARD_CLASS} {
    padding: 60px;

    ${XSM_DOWN} {
      padding: 40px;
    }

    ${XXSM_ONLY} {
      padding: 40px 20px;
    }
  }

  .${POPUP_CARD_NO_PADDING_CLASS} {
    padding: 0;
  }
`
